/* ============================================================
   tomosu — Product CVR enhancements (JS)
   1) スマホ追従購入バー（既存の購入ボタンへ委譲。カート処理は再利用）
   2) 商品概要のアコーディオン化（<hr>区切り → <details>）
   進化的拡張：JS無効でも素のページは完全に機能する。
   ============================================================ */
(function () {
  'use strict';

  /* ---------- 1) スマホ追従購入バー ---------- */
  class StickyBuyBar extends HTMLElement {
    connectedCallback() {
      const id = this.dataset.sectionId;
      this.priceSource = document.getElementById('price-' + id);
      this.priceTarget = this.querySelector('.sticky-buy-bar__price');
      this.btn = this.querySelector('.sticky-buy-bar__btn');
      this.btnLabel = this.querySelector('.sticky-buy-bar__btn-label');
      const info = document.getElementById('ProductInfo-' + id);
      // 本物の購入ボタン（フォーム送信ボタン）を探す
      this.realSubmit =
        (info && info.querySelector('.product-form__submit')) ||
        document.querySelector('#ProductInfo-' + id + ' .product-form__submit') ||
        document.querySelector('.product-form__submit');

      if (!this.realSubmit) {
        // フォームが無ければ追従バーは出さない
        this.remove();
        return;
      }

      // クリックは本物のボタンへ委譲（=Dawnのバリエーション検証/Ajax追加/カート通知を再利用）
      if (this.btn) {
        this.btn.addEventListener('click', () => {
          if (this.realSubmit.hasAttribute('disabled')) {
            this.realSubmit.scrollIntoView({ behavior: 'smooth', block: 'center' });
            return;
          }
          this.realSubmit.click();
        });
      }

      this._syncPrice();
      this._syncBtn();

      // 価格の変化（バリエーション切替）をミラー
      if (this.priceSource && 'MutationObserver' in window) {
        this._priceObs = new MutationObserver(() => this._syncPrice());
        this._priceObs.observe(this.priceSource, { subtree: true, childList: true, characterData: true });
      }
      // 売り切れ/在庫切れ等のボタン状態をミラー
      if ('MutationObserver' in window) {
        this._btnObs = new MutationObserver(() => this._syncBtn());
        this._btnObs.observe(this.realSubmit, { attributes: true, childList: true, subtree: true });
      }

      // 本物ボタンが画面内に見えている間は追従バーを隠す
      if ('IntersectionObserver' in window) {
        this._io = new IntersectionObserver(
          (entries) => {
            entries.forEach((e) => {
              this.hidden = e.isIntersecting;
            });
          },
          { rootMargin: '0px 0px -8% 0px', threshold: 0 }
        );
        this._io.observe(this.realSubmit);
      } else {
        this.hidden = false;
      }
    }

    disconnectedCallback() {
      if (this._priceObs) this._priceObs.disconnect();
      if (this._btnObs) this._btnObs.disconnect();
      if (this._io) this._io.disconnect();
    }

    _syncPrice() {
      if (!this.priceSource || !this.priceTarget) return;
      const node =
        this.priceSource.querySelector('.price-item--sale:not([hidden])') ||
        this.priceSource.querySelector('.price-item--regular') ||
        this.priceSource;
      const txt = (node.textContent || '').trim();
      if (txt) this.priceTarget.textContent = txt;
    }

    _syncBtn() {
      if (!this.btn) return;
      const disabled = this.realSubmit.hasAttribute('disabled');
      this.btn.toggleAttribute('disabled', disabled);
      if (this.btnLabel) {
        const realText = this.realSubmit.querySelector('span:not(.svg-wrapper)');
        const label = realText ? realText.textContent.trim() : this.realSubmit.textContent.trim();
        if (label) this.btnLabel.textContent = label;
      }
    }
  }
  if (!customElements.get('sticky-buy-bar')) {
    customElements.define('sticky-buy-bar', StickyBuyBar);
  }

  /* ---------- 2) 商品概要アコーディオン ---------- */
  function buildDescriptionAccordion() {
    const box = document.querySelector('[data-product-accordion]');
    if (!box || box.dataset.accordionDone) return;

    const raw = box.innerHTML;
    if (!/<hr\s*\/?>/i.test(raw)) return; // 区切りが無ければ素のまま表示

    const parts = raw
      .split(/<hr\s*\/?>/i)
      .map((s) => s.trim())
      .filter(Boolean);
    if (parts.length < 2) return;

    const frag = document.createDocumentFragment();
    parts.forEach((part, i) => {
      const tmp = document.createElement('div');
      tmp.innerHTML = part;

      const head = tmp.querySelector('h1, h2, h3, h4');
      let title = head ? head.textContent.trim() : '詳細 ' + (i + 1);
      title = title.replace(/^[〈【]\s*|\s*[〉】]$/g, '').trim() || '詳細 ' + (i + 1);
      if (head) head.remove();

      const details = document.createElement('details');
      details.className = 'product-acc__item';
      if (i === 0) details.open = true;

      const summary = document.createElement('summary');
      summary.className = 'product-acc__summary';
      summary.innerHTML =
        '<span class="product-acc__summary-text"></span>' +
        '<span class="product-acc__chev" aria-hidden="true"></span>';
      summary.querySelector('.product-acc__summary-text').textContent = title;

      const body = document.createElement('div');
      body.className = 'product-acc__body rte';
      body.innerHTML = tmp.innerHTML;

      details.appendChild(summary);
      details.appendChild(body);
      frag.appendChild(details);
    });

    box.innerHTML = '';
    box.appendChild(frag);
    box.dataset.accordionDone = '1';
    box.classList.add('product-acc');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildDescriptionAccordion);
  } else {
    buildDescriptionAccordion();
  }
})();
